export default __webpack_public_path__ + "static/media/serviceable.d5cd68f5.jpg";